import { useLayoutEffect } from "react";
import { useUpdateNodeInternals } from "@xyflow/react";

export function useMeasuredHandles(nodeId: string, enabled: boolean | undefined): void {
  const updateNodeInternals = useUpdateNodeInternals();

  useLayoutEffect(() => {
    if (!enabled) return;
    updateNodeInternals(nodeId);
  }, [enabled, nodeId, updateNodeInternals]);
}
